import { render, staticRenderFns } from "./Forwarder.vue?vue&type=template&id=32e1c343"
import script from "./forwarder.ts?vue&type=script&lang=js&external"
export * from "./forwarder.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports